/**
 * Show google map with clickable lat long point for choosing a start point etc
 */
admin.registerLoad(function (prefix) {
    $(prefix + '.js-date-picker').datepicker({
        format: 'dd/mm/yyyy',
        autoclose: true
    });

    $(prefix + '.js-date-null ').each(function () {

        var inputid = $(this).data("input-id");

        $(this).change(function () {
            if ($(this).prop("checked"))
            {
                $('#' + inputid).val("");
                $('#' + inputid + '-time').val("");
            }
        });

        $('#' + inputid).change(function () {
            $('#' + inputid + '-null').prop('checked', false);
        });

        $('#' + inputid + '-time').change(function () {
            $('#' + inputid + '-null').prop('checked', false);
        });
    });

});